import { createApp } from 'vue'
import App from './App.vue'
import './assets/styles/main.scss'
import { Ionicons } from 'ionicons/icons';
import router from './router/'
import Toaster from '@meforma/vue-toaster';

const app = createApp(App)
app.use(Ionicons)
app.use(router)
app.use(Toaster)
app.mount('#app')